/**
 * The dark message bar near the bottom of the screen (docs/design/HANDOFF.md,
 * "Message bar with Undo"). Rendered through react-toastify by
 * `util/messageBar.js`; this is only the look. `onPause` / `onResume` hold the
 * timer while a mouse pointer or keyboard focus is on the bar (not on a tap,
 * which would leave it stuck open on a phone).
 */
const MessageBar = ({ text, undoLabel = "Undo", onUndo = null, onPause = null, onResume = null }) => (
  <div
    role="status"
    onPointerEnter={(e) => e.pointerType === "mouse" && onPause?.()}
    onPointerLeave={(e) => e.pointerType === "mouse" && onResume?.()}
    onFocus={onPause || undefined}
    onBlur={onResume || undefined}
    className="flex min-h-[52px] w-full items-center justify-between gap-3 text-[15px] text-white"
  >
    <span className="py-2">{text}</span>
    {onUndo ? (
      <button
        type="button"
        onClick={onUndo}
        className="h-11 flex-shrink-0 rounded-[10px] px-4 text-[15px] font-bold text-[#F4B6C0] focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
      >
        {undoLabel}
      </button>
    ) : null}
  </div>
);

export default MessageBar;
